<template>
    <div class="copy-popup-background" @click="closePopup($event)">
        <div class="copy-popup">
            <div class="image-holder">
                <img :src="this.image.href">
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name: 'imagePopup',
    props: ['image'],

    methods: {

        closePopup() {
            this.$parent.showImagePopup = false;
        }

    },

}
</script>

<style lang="scss" scoped>

.copy-popup-background{
    display:flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width:100%;
    height:100%;
    top:0;
    left:0;
    z-index: 1092;
}

.copy-popup {
    background: #fff;
    border: 1px #d3020c solid;
    width: 580px;
    max-height: 95vh;

    .image-holder {

        padding: 20px;
        position: relative;
        display: block !important;

        img {
            max-width: 100%;
            max-height: 85vh;
            display: block;
            margin: 0 auto;
        }

    }

}

</style>